export const isVertical = () => {
    return window.innerHeight * 1.2 > window.innerWidth
}